import { render, staticRenderFns } from "./DeviceConfig.vue?vue&type=template&id=65ffb0cf&scoped=true"
import script from "./DeviceConfig.vue?vue&type=script&lang=js"
export * from "./DeviceConfig.vue?vue&type=script&lang=js"
import style0 from "./DeviceConfig.vue?vue&type=style&index=0&id=65ffb0cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ffb0cf",
  null
  
)

export default component.exports